import {
  GETMEETING,
  GETALLMEETING,
  CREATEMEETING,
  UPDATEMEETING,
  DELETEMEETING,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEMEETING:
      return {
        ...state,
        liveMeetingSaveStatus: action.payload.success,
      };
    case GETMEETING:
      return {
        ...state,
        liveMeetingList: action.payload.data,
      };
    case GETALLMEETING:
      return {
        ...state,
        liveMeetingAllList: action.payload.data,
      };
    case UPDATEMEETING:
      return {
        ...state,
        liveMeetingUpdateStatus: action.payload.success,
      };

    case DELETEMEETING:
      return {
        ...state,
        liveMeetingDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
